import React from 'react';
import styled from 'styled-components';

import { IFeature, IGlassesPackage } from '../../types';
import { BaseCheck } from '../../svg/Check';
import { breakpoints, colors, spacing } from '../../constants';

interface IFeatureProps {
    $isActive: boolean;
}

export const Feature = styled.li<IFeatureProps>`
    padding: 5px 0;
    color: ${(props) =>
        props.$isActive ? colors.black : colors.transparentBlack};
    display: flex;
    align-items: center;
    font-size: 15px;

    @media (${breakpoints.mediumMin}) {
        font-size: 16px;
    }
`;

const Check = styled(BaseCheck)`
    width: 16px;
    height: 16px;
    stroke: ${colors.black};
    margin-right: 10px;
`;

const CheckHolder = styled.div`
    width: 26px;
`;

interface IProps {
    features: IFeature[];
    glassesPackage: IGlassesPackage;
    className?: string;
}

const BaseFeatureList = ({
    features,
    glassesPackage: { featureIds },
    className,
}: IProps) => (
    <ul className={className}>
        {[...features].map((feature) => {
            const isActive = featureIds.includes(feature.id);

            return (
                <Feature $isActive={isActive} key={feature.id}>
                    <CheckHolder>{isActive && <Check />}</CheckHolder>
                    {feature.name}
                </Feature>
            );
        })}
    </ul>
);

export const FeatureList = styled(BaseFeatureList)`
    margin-bottom: ${spacing.lg};

    @media (${breakpoints.mediumMin}) {
        padding-right: 40px;
        margin-bottom: 0;
    }
`;
